<template>
  <div v-if="plate">
    <template v-if="appQuestion === 'prosperity_life'">
      <div class="d-flex justify-space-between">
        <h2>
          Have you ever been diagnosed, treated, or prescribed medication for:
        </h2>

        <PlateHealthPriority />
      </div>

      <p class="mt-4">
        Parkinson's disease, systemic lupus, sickle cell disease, cirrhosis of
        the liver, chronic hepatitis, liver disorder, kidney failure or other
        chronic kidney disease?
      </p>

      <v-radio-group v-model="plate.prosperity.q1" class="radio-questions" row>
        <v-radio label="Yes" :value="true" />
        <v-radio label="No" :value="false" />
      </v-radio-group>

      <p class="mt-4">
        Chronic Obstructive Pulmonary Disease (COPD), which includes emphysema,
        black lung disease or tuberculosis? Disabled Need a Summary
      </p>

      <v-radio-group v-model="plate.prosperity.q2" class="radio-questions" row>
        <v-radio label="Yes" :value="true" />
        <v-radio label="No" :value="false" />
      </v-radio-group>

      <p class="mt-4">
        Bipolar Disorder or Schizophrenia or been hospitalized in the past 2
        years for any mental or nervous disorder?
      </p>

      <v-radio-group v-model="plate.prosperity.q3" class="radio-questions" row>
        <v-radio label="Yes" :value="true" />
        <v-radio label="No" :value="false" />
      </v-radio-group>
    </template>
    <template v-else>
      <div class="d-flex justify-space-between">
        <h2>
          Have you ever been diagnosed, treated, or advised to seek treatment
          for:
        </h2>

        <PlateHealthPriority />
      </div>

      <p class="mt-4">COPD, Chronic, bronchitis, or emphysema?</p>

      <v-radio-group v-model="plate.liberty.isChronic" class="radio-questions" row>
        <v-radio label="Yes" :value="true" />
        <v-radio label="No" :value="false" />
      </v-radio-group>

      <p class="mt-4">
        Irregular heartbeat, Atrial fibrillation, or any central artery or
        vascular disease?
      </p>

      <v-radio-group v-model="plate.liberty.isHeartbeat" class="radio-questions" row>
        <v-radio label="Yes" :value="true" />
        <v-radio label="No" :value="false" />
      </v-radio-group>

      <h2>
        Have you in the last 2yrs been diagnosed with or received treatment for:
      </h2>

      <p class="mt-4">Epileptic seizures or TIA ministrokes?</p>

      <v-radio-group v-model="plate.liberty.isEpileptic" class="radio-questions" row>
        <v-radio label="Yes" :value="true" />
        <v-radio label="No" :value="false" />
      </v-radio-group>
    </template>

    <PlateFooter :onBack="onBack" :onSubmit="onSubmit" :isLoading="isLoading" />
  </div>
</template>

<script>
import { format } from 'date-fns';
import { PlatesSteps } from '@/common/variables';
import PlateFooter from '@/components/lead/plates/PlateFooter';
import PlateHealthPriority from '@/components/lead/plates/PlateHealthPriority';
import { mapGetters } from 'vuex';

export default {
  name: 'DisabledHealthSecondPlate',
  components: {
    PlateHealthPriority,
    PlateFooter,
  },
  props: {
    agent: {
      type: Object,
    },
    lead: {
      type: Object,
    },
  },
  data: () => ({
    plate: null,
    isLoading: false,
  }),
  computed: {
    ...mapGetters({
      appQuestion: 'plates/appQuestion',
    }),
  },
  mounted() {
    const { data } = this.$store.getters['plates/dataByStep'](
      PlatesSteps.disabledHealthSecond
    );
    this.plate = data;
  },
  methods: {
    format,
    onBack() {
      this.$store.commit('plates/setStep', PlatesSteps.disabledHealthFirst);
    },
    onSubmit() {
      if (this.appQuestion === 'prosperity_life') {
        if (Object.values(this.plate.prosperity).find(Boolean)) {
          this.$store.commit('plates/setAppRate', 'gb');
        } else {
          this.$store.commit('plates/setAppRate', 'lb');
        }
      } else {
        if (Object.values(this.plate.liberty).find(Boolean)) {
          this.$store.commit('plates/setAppRate', 'gb');
        } else {
          this.$store.commit('plates/setAppRate', 'lb');
        }
      }

      this.$store.commit('plates/setStep', PlatesSteps.generalHealth);
      this.$store.dispatch('plates/updatePlate', this.lead);
    },
  },
};
</script>

<style></style>